<template>
  <el-container style="height: 100vh; border: 1px solid #eee">
    <el-aside class="m-nav" :width="navWidth" style="background-color: #232b35">
      <div class="pt20 pl20 pr15 flex items-center">
        <img v-if="channel == 'oppo'" src="@/assets/oppo_logo.png" alt="" width="30">
        <img v-else-if="channel == 'chuanyin'" src="https://transsion.com/favicon.ico" alt="" width="30">
        <img v-else-if="channel == 'vivo'" src="@/assets/vivo_logo.png" alt="" width="30">
        <img v-else src="@/assets/logo.png" alt="" width="30">
        <div class="ml10 fs12" style="color: white;">{{title}}</div>
      </div>
      <el-menu style="background-color: #232b35;" class="mt25" @select="handleSelect">
        <el-submenu :index="item.id" v-for="item in menu" :key="item.id">
          <template slot="title"><i :class="item.icon"></i>{{item.title}}</template>
          <el-menu-item-group>
            <el-menu-item v-if="(child.enabled == null || child.enabled() == true) && menuVisible(child)" :index="child.id" v-for="child in item.children" :key="child.id">{{child.title}}</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
    </el-aside>
    
    <el-container>
      <el-header style="text-align: left; font-size: 18px; height: 50px; background-color: white;">
        <div class="h100 flex items-center">
          <div style="cursor: pointer;" @click="foldNav">
            <i :class="isFold ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
          </div>
          <div class="flex-width flex items-center ml10">
            <!-- <div class="m-tab" :class="curPath == tab.id ? 'active' : ''" v-for="(tab, index) in tabs" :key="index" @click="handleSelect(tab.id)">
              <i class="el-icon-star-on"></i>
              <span>{{tab.title}}</span>
              <i class="el-icon-close" @click="closeTab(tab.id)"></i>
            </div> -->
          </div>
          <div v-if="channel == 'xm'">
            <el-select @change="onChangeLine" v-model="currentLine" style="width: 100px;" placeholder="线路" size="mini">
                <el-option
                    v-for="item in lines"
                    :key="item.name"
                    :label="item.name"
                    :value="item.host">
                </el-option>
            </el-select>
          </div>
          <div class="ml15">
            <el-button size="mini" @click="logout">退出登陆</el-button>
          </div>
        </div>
      </el-header>
      
      <el-main>
        <keep-alive>
          <router-view/>
        </keep-alive>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
// @ is an alias to /src
import menu from '../data/menu';

// import AppView from './AppView.vue';
// import GameData from './GameData.vue';
// import AdData from './AdData.vue';
// import AdGroup from './AdGroup.vue';
// import Downstream from './Downstream.vue';
// import PatchView from './PatchView.vue';
// import GameReports from './GameReports.vue';
// import Apps from './Apps.vue';
// import Collocation from './Collocation.vue';

export default {
  // components: {
  //   AppView,
  //   GameData,
  //   AdData,
  //   AdGroup,
  //   Downstream,
  //   PatchView,
  //   GameReports,
  //   Apps,
  //   Collocation
  // },
  data() {
    return {
      navWidth: "250px",
      isFold: false,
      menu,
      routers: {},
      routerItems: {},
      tabs: [],
      curPath: null,
      tab: {
        "2-1": false
      },
      cacheViews: [
        "AppView", "GameData", "AdData", "AdGroup", "Downstream", "PatchView", "GameReports", "Apps", "Collocation", "AdRevenue"
      ],
      currentLine: "国内加速",
      lines: [
        {
          // name: "国内加速", host: "https://mi.91mgame.com:8443"
          name: "国内加速", host: "https://miapi.felixtech.cn"
        },
        {
          name: "国际加速", host: "https://xmapi.cloudyproxy.com"
        }
      ],
      permission: 0,
      channel: null,
      title: "数据后台"
    }
  },
  created() {
    this.channel = window.channel;
    let path = window.location.pathname;
    this.routers = {};
    this.permission = this.$api.request_body.permission;
    // alert(this.permission)
    // this.curPath = "2-1"

    let hasDefault = false;
    for (let item of menu) {
      for (let child of item.children) {
        this.routers[child.id] = child.url
        this.routerItems[child.id] = child;
        if (path === child.url) {
          this.curPath = child.id; // 设置当前路径
          this.tab[child.id] = true; // 设置当前标签页为选中状态
          this.tabs.push(child); // 初始化时添加当前路由到标签页
          hasDefault = true;
          // break;
        }
      }

    }
    if (window.channel == 'xm') {
      this.title = "小米数据后台";
    } else if (window.channel == 'oppo') {
      this.title = "OPPO数据后台";
    } else if (window.channel == 'chuanyin') {
      this.title = "传音数据后台";
    } else if (window.channel == 'vivo') {
      this.title = "VIVO数据后台";
    } else {
      this.title = "数据后台";
    }

    // console.log("当前路径:", path, menu, this.routers);

    
    if (!hasDefault) {
      this.handleSelect("2-1", null);
    }

    if (this.channel == 'xm') {
      // let line = window.localStorage.getItem("request_host");
      // if (line) {
      //   for (let it of this.lines) {
      //     if (it.host == line) {
      //       this.currentLine = it.name;
      //       break;
      //     }
      //   }
      //   window.request_host = line;
      // } else {
      //   for (let it of this.lines) {
      //     if (it.name == this.currentLine) {
      //       window.request_host = it.host;
      //       break;
      //     }
      //   }
      // }
    }
  },
  methods: {
    menuVisible(child) {
      return child.permission.indexOf(this.permission) != -1;
    },
    foldNav() {
      this.isFold = !this.isFold;
      this.navWidth = this.isFold ? "0px" : "250px"
    },
    handleSelect(key, keyPath) {
      if (this.curPath != key) {
        // console.log(this.routers, key, this.routers[key])
        this.$router.push(this.routers[key])
        this.curPath = key;
        this.tab[key] = true;

        let item = this.routerItems[key];
        if (this.tabs.some(tab => tab.id === item.id)) {
          return; // 如果标签已存在，则不添加
        }
        this.tabs.push(item)
      }
    },
    closeTab(id) {
      this.tabs.findIndex((tab, index) => {
        if (tab.id === id) {
          this.tabs.splice(index, 1);
          this.tab[id] = false; // 移除标签页
          if (this.curPath === id) {
            // 如果关闭的是当前选中的标签，则跳转到第一个标签
            if (this.tabs.length > 0) {
              this.handleSelect(this.tabs[this.tabs.length - 1].id);
            } else {
              this.$router.push("/"); // 如果没有标签了，跳转到登录页
              this.curPath = "1-1";
            }
          }
          return true; // 找到并删除后退出循环
        }
        return false; // 继续查找
      });
    },
    logout() {
      this.$api.logout();
      this.$router.push("/admin_login");
    },
    onChangeLine(e) {
      console.log(e)
      window.request_host = e;
      window.localStorage.setItem("request_host", e);
      this.$message.success("切换线路成功");
    }
  }
}
</script>

<style lang="less" scoped>
.m-nav {
  transition: width 0.15s ease;
}

.m-tab {
  padding: 0 10px;
  height: 100%;
  line-height: 26px;
  height: 26px;
  color: #333;
  cursor: pointer;
  font-size: 12px;
  border: 1px solid #eee;
  // border-radius: 5px;
  align-items: center;
  display: flex;
  margin-right: 10px;

  .el-icon-close {
    margin-left: 2px;
  }

  .el-icon-star-on {
    display: none;
  }
  
  &.active {
    background-color: #4480e9;
    color: #fff;
    border: 1px solid #4480e9;
    .el-icon-star-on {
      display: inline-block;
      margin-right: 2px;
    }
    .el-icon-close {
      display: inline-block;
      margin-left: 2px;

    }
    // &:hover {
    //   .el-icon-close {
    //     opacity: 1;
    //     transition: opacity 0.3s ease;
    //   }
    // }
  }
  
}

/deep/.el-submenu__title {
  color: #939eaa!important;
  text-align: left;
  display: flex;
  align-items: center;
  height: 44px;
  i {
    transition: border-color .3s, background-color .3s, color .3s;
  }
}
/deep/.el-submenu__title:hover {
  background-color: #232b35;
  color: #f4f6f8!important;
  i {
    color: #f4f6f8!important;
  }
}
/deep/.el-menu {
  background-color: #232b35;
}
/deep/.el-menu-item-group {
  background-color: #232b35;
}
/deep/.el-menu-item {
  color: #939eaa!important;
  text-align: left;
  height: 35px;
  line-height: 35px;

  &.is-active {
    background-color: #232b35;
    color: white!important;
  }
}
/deep/.el-menu-item:hover {
  background-color: #232b35;
  color: #f4f6f8!important;
}
/deep/.el-menu-item-group__title {
  display: none!important;
}
</style>
